
    import React from 'react'
    import Base from '@ucheba/ui/components/Icon'
    import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js"
    import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js"

    const symbol = new SpriteSymbol({
  "id": "icon__uchebaru_minimized",
  "use": "icon__uchebaru_minimized-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon__uchebaru_minimized\"><path d=\"M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0Zm2.38 7.723s.789-.264.752.493c-.187.542-1.29 2.92-1.966 3.862-.338-.19-1.302-3.19-1.815-5.273-.6-2.082-3.985-.128-3.985-.128l.169.845c.768-.445 1.362-.468 1.582.394.512 2.007.965 5.86 3.121 5.848-.244.51-1.65 2.722-3.071 2.215.767-.447.773-1.514.327-1.975-.929-.963-2.317-.47-2.856.595-.346.683-.291 1.426.01 2.057.76 1.593 2.754 1.955 4.223 1.218 2.71-1.36 4.937-6.061 6.136-8.603.381-.81.845-1.824.43-2.686-.76-1.576-3.598-.727-3.056 1.138Z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
})
    sprite.add(symbol)

    export default React.memo(function IconUchebaruMinimizedIcon(props) {
      const { className, ...restProps } = props
      return <Base.Icon className={className} id="icon__uchebaru_minimized" {...restProps} />
    })
  